import { ajaxAuth } from "@tm/utils"
import { WebserviceUrl } from "../../../webserviceUrls"
import { GetAdvertisementCategoriesResponse } from "./model"

export function getAdvertisementCategories() {
    const url = `${WebserviceUrl.ErpConnect}/GetAdvertisementCategories`
    const body = {}

    return ajaxAuth<GetAdvertisementCategoriesResponse>({ url, body })
}
